export default "__VITE_ASSET__CYd4g2yC__"